import { KeenSliderInstance } from "keen-slider";
import { getSliderMaxIdx } from "../keen-slider-utils";

export default function keenNavigationPlugin(slider: KeenSliderInstance) {
    let sliderContent: HTMLElement,
        dotsWrapper: HTMLElement,
        arrowLeft: HTMLElement,
        arrowRight: HTMLElement,
        currentSlideInfoWrapper: HTMLElement;

    function markup() {
        wrapperMarkup();
        dotMarkup();
        arrowMarkup();
        currentSlideInfoMarkup();
    }

    function removeMarkups() {
        while (sliderContent.firstChild) sliderContent.parentNode.insertBefore(sliderContent.firstChild, sliderContent);
        removeElement(sliderContent);

        removeElement(arrowLeft);
        removeElement(arrowRight);

        removeElement(dotsWrapper);

        removeElement(currentSlideInfoWrapper);
    }

    function removeElement(element: HTMLElement) {
        element?.remove();
    }

    function createElement(elementName: string, className: string) {
        const div = document.createElement(elementName);
        const classNames = className.split(" ");
        classNames.forEach((name) => div.classList.add(name));
        return div;
    }

    function wrapperMarkup() {
        sliderContent = createElement("div", "keen-slider__content");
        slider.container.parentNode.appendChild(sliderContent);

        sliderContent.appendChild(slider.container);
    }

    function arrowMarkup() {
        arrowLeft = createElement("div", "keen-slider__arrow keen-slider__arrow--left");
        arrowLeft.addEventListener("click", () => slider.prev());
        arrowRight = createElement("div", "keen-slider__arrow keen-slider__arrow--right");
        arrowRight.addEventListener("click", () => slider.next());

        sliderContent.appendChild(arrowLeft);
        sliderContent.appendChild(arrowRight);
    }

    function dotMarkup() {
        const maxIdx = getSliderMaxIdx(slider);
        if (!maxIdx) {
            return;
        }

        dotsWrapper = createElement("ul", "keen-slider__dots");

        [...Array(maxIdx + 1).keys()].forEach((idx) => {
            const dot = createElement("li", "keen-slider__dot");
            dot.addEventListener("click", () => slider.moveToIdx(idx));
            dotsWrapper.appendChild(dot);
        });
        sliderContent.parentNode.appendChild(dotsWrapper);
    }

    function updateCurrentSlideInfo(rel, maxIdx) {
        currentSlideInfoWrapper.innerHTML = rel + 1 + "/" + (maxIdx + 1);
    }

    function currentSlideInfoMarkup() {
        currentSlideInfoWrapper = createElement("div", "keen-slider__current-slide-info");

        const { rel } = slider.track.details;
        const maxIdx = getSliderMaxIdx(slider);
        updateCurrentSlideInfo(rel, maxIdx);

        sliderContent.parentNode.appendChild(currentSlideInfoWrapper);
    }

    function updateClasses() {
        const { rel } = slider.track.details;
        const maxIdx = getSliderMaxIdx(slider);

        if (!slider.options.loop) {
            rel === 0
                ? arrowLeft.classList.add("keen-slider__arrow--disabled")
                : arrowLeft.classList.remove("keen-slider__arrow--disabled");
            rel === maxIdx
                ? arrowRight.classList.add("keen-slider__arrow--disabled")
                : arrowRight.classList.remove("keen-slider__arrow--disabled");
        }

        if (dotsWrapper?.children.length) {
            Array.from(dotsWrapper.children).forEach(function (dot, idx) {
                idx === rel
                    ? dot.classList.add("keen-slider__dot--active")
                    : dot.classList.remove("keen-slider__dot--active");
            });
        }

        updateCurrentSlideInfo(rel, maxIdx);
    }

    slider.on("created", () => {
        markup();
        updateClasses();
    });
    slider.on("optionsChanged", () => {
        removeMarkups();
        markup();
        updateClasses();
    });
    slider.on("slideChanged", () => {
        updateClasses();
    });
    slider.on("destroyed", () => {
        removeMarkups();
    });
}
